/* ----------------------------- */
/*   Reducer for the Outage Set
/* ----------------------------- */

import { SET_OUTAGE_BANNER, CLOSE_OUTAGE_BANNER } from 'AppSrc/core/components/outage-banner/outage-constant';

const defaultUserState = {
  outage: false,
};

const outageBannerReducerDefaultState = {
  banner: defaultUserState,
};

const outageBannerReducer = (state = outageBannerReducerDefaultState, action) => {

  switch (action.type) {
    // Banner Close
    case CLOSE_OUTAGE_BANNER: {
      const { outage } = action.payload;
      return {
        ...state,
        banner: {
          outage,
        },
      };
    }
    // Banner Set
    case SET_OUTAGE_BANNER: {
      const { outage } = action.payload;
      return {
        ...state,
        banner: {
          outage,
        },
      };
    }

    default:
      return state;
  }
};

export {
  outageBannerReducer,
  outageBannerReducerDefaultState,
};

